<template>
  <v-app>
    <v-main>
      <template v-if="application">
        <map-wrapper v-if="!configureError" />
        <v-img v-else-if="params('draft') === 'true'">
          <v-container class="px-5">
            <v-col class="text-center px-5 mb-5">
              <v-alert
                :value="true"
                type="warning"
                outlined
              >
                <h3>{{ configureError }}</h3>
              </v-alert>
            </v-col>
          </v-container>
        </v-img>
      </template>
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import MapWrapper from './components/MapWrapper.vue'

export default {
  name: 'App',
  components: {
    MapWrapper
  },
  data: () => ({}),
  computed: {
    ...mapState(['application', 'dataset']),
    ...mapGetters(['datasetUrl', 'parcelleIdField']),
    configureError () {
      if (!this.datasetUrl) return 'Veuillez sélectionner une source de données'
      if (!this.parcelleIdField) return 'Cette source de données ne contient pas d\'identifiants de parcelle'
      return null
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      async handler () {
        const conceptFilters = {}
        for (const key in this.$route.query) {
          if (key.startsWith('_c_')) {
            conceptFilters[key] = this.$route.query[key]
          }
        }
        this.$store.commit('setAny', { conceptFilters })
        if (!this.configureError) this.$store.dispatch('init')
      }
    }
  },
  mounted () {
    window.vIframeOptions = {
      router: this.$router,
      reactiveParams: true
    }
  },
  methods: {
    params (p) {
      const params = new URLSearchParams(window.location.search)
      return params.get(p)
    }
  }
}
</script>

<style>
.v-application {
  font-family: "Nunito", sans-serif!important;
}
</style>
